"use client";

import { c as _c } from "react/compiler-runtime";
import { Slider } from "@base-ui/react/slider";
import { formatDuration } from "@/lib/format-duration";
interface VideoScrubberProps {
  max: number;
  onSeek: (time: number) => void;
  value: number;
}
export default function VideoScrubber(t0) {
  const $ = _c(13);
  const {
    value,
    max,
    onSeek
  } = t0;
  const duration = Number.isFinite(max) && max > 0 ? max : 0;
  const t1 = duration === 0;
  const t2 = duration || 1;
  const t3 = Math.min(value, duration);
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Slider.Track className="relative h-1 w-full overflow-hidden rounded-full bg-white/30"><Slider.Indicator className="absolute h-full bg-white" /></Slider.Track>;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== value) {
    t5 = formatDuration(value);
    $[1] = value;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== duration) {
    t6 = formatDuration(duration);
    $[3] = duration;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = `${t5} of ${t6}`;
  let t8;
  if ($[5] !== t7) {
    t8 = <Slider.Control className="relative flex h-6 w-full cursor-crosshair items-center rounded-full has-focus-visible:outline-2 has-focus-visible:outline-white has-focus-visible:outline-offset-4">{t4}<Slider.Thumb aria-label="Seek" aria-valuetext={t7} className="size-3 rounded-full outline-none" /></Slider.Control>;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== onSeek || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t8) {
    t9 = <Slider.Root className="min-w-0 grow touch-none select-none" disabled={t1} largeStep={1} max={t2} min={0} onValueChange={onSeek} step={0.1} value={t3}>{t8}</Slider.Root>;
    $[7] = onSeek;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
}